import { Dispatch, SetStateAction } from "react";

import { TFunction } from "i18next";

import { ROUTES } from "../../shared";
import { DETAILS_TITLE_AREA_OPTIONS, DetailsDto } from "./types";

export const renderTitle = (detailsData: DetailsDto, route: ROUTES) => {
  if (detailsData) {
    switch (route) {
      case ROUTES.Vehicles:
        return {
          title: DETAILS_TITLE_AREA_OPTIONS.VehicleRegistrationNumber,
          value: detailsData.number,
          copy: true
        };

      case ROUTES.Drivers:
        return {
          title: DETAILS_TITLE_AREA_OPTIONS.Driver,
          value: detailsData.cardName,
          copy: false
        };

      case ROUTES.Companies:
      case ROUTES.Integrations:
      case ROUTES.AnalysisProviders:
        return { title: null, value: detailsData.name, copy: false };

      default:
        return {};
    }
  }
};

export const checkCardNameError = (
  errorMessage: string | null,
  setCardNameError: Dispatch<SetStateAction<string | null>>,
  t: TFunction<"translation", undefined>
) => {
  errorMessage === t("Alert##Company card with such name already exists.") &&
    setCardNameError(errorMessage);
};
